export function CommissionsTable({ commissions }) {
  return (
    <div className="bg-white border border-black p-6">
      <h3 className="text-lg font-bold mb-4">Commission History</h3>
      {commissions.length > 0 ? (
        <div className="space-y-3">
          {commissions.slice(0, 10).map((c) => (
            <div
              key={c.transaction_id || `${c.created_at}-${c.amount}`}
              className="flex items-center justify-between border-b border-gray-100 pb-3"
              data-testid="commission-item"
            >
              <div>
                <p className="font-medium text-green-600">+${c.amount.toFixed(2)}</p>
                <p className="text-sm text-gray-500">
                  {c.plan} plan &bull; {new Date(c.created_at).toLocaleDateString()}
                </p>
              </div>
              <span
                className={`px-2 py-1 text-xs font-bold ${
                  c.status === "paid" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"
                }`}
              >
                {c.status.toUpperCase()}
              </span>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No commissions yet. Referrals who upgrade will earn you 20%!</p>
      )}
    </div>
  );
}
